import { useTranslation } from 'react-i18next'

import { Badge, HStack } from '@enechain/ecloud-designsystem'

import type { VoltageClass } from '~/models/voltageBreakdown'
import { VOLTAGE_I18N_KEY } from '~/pages/CustomerInfo/models/display'

/** 電圧階級のチップ (1 行固定。 複数階級をまたぐ需要家は並べる)。 */
export const VoltageBadges = ({
  voltages,
}: {
  voltages: readonly VoltageClass[]
}): React.ReactElement => {
  const { t } = useTranslation()
  return (
    <HStack gap={1} whiteSpace="nowrap">
      {voltages.map((v) => (
        <Badge key={v} status="neutral">
          {t(VOLTAGE_I18N_KEY[v])}
        </Badge>
      ))}
    </HStack>
  )
}
